
cc.Class({
    extends: cc.Component,

    properties: {
        spine: sp.Skeleton,
        animations: [cc.String]
    },

    start () {
        this.onLandscape();

    },

    onLandscape() {
        // this.node.setPosition(0, -82);
        this.spine.setAnimation(0, this.animations[0], true);
    },

    onPortrait() {
        // this.node.setPosition(0, 0);
        this.spine.setAnimation(0, this.animations[1], true);
    }

});
